"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.breadcrumbReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var BreadcrumbAction_1 = require("@/pages/search/actions/sfilter/BreadcrumbAction");
var BreadcrumbState_init_1 = require("@/pages/search/states/BreadcrumbState.init");
exports.breadcrumbReducer = function (state, action) {
    if (state === void 0) { state = BreadcrumbState_init_1.defaultBreadcrumbState; }
    switch (action.type) {
        case typesafe_actions_1.getType(BreadcrumbAction_1.default.setBreadcrumb): {
            return __assign(__assign({}, state), { breadcrumbList: action.payload });
        }
        case typesafe_actions_1.getType(BreadcrumbAction_1.default.setBreadcrumbSearchUrl): {
            if (state.breadcrumbList[1].link.indexOf('/property-search/') === -1) {
                return state;
            }
            var newSearchMenuItem = __assign(__assign({}, state.breadcrumbList[1]), { link: action.payload });
            return __assign(__assign({}, state), { breadcrumbList: __spreadArrays([
                    state.breadcrumbList[0],
                    newSearchMenuItem
                ], state.breadcrumbList.slice(2)) });
        }
    }
    return state;
};
